// Stylized service-zone map for RS Handyman Services.
// Delmarva Peninsula highlighted with orange zone overlay.
export default function ZoneMap({ className = "", ...rest }) {
  return (
    <svg
      viewBox="0 0 600 780"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="RS Handyman Services zone map — Eastern Shore Maryland and Delaware"
      className={className}
      {...rest}
    >
      <defs>
        <linearGradient id="zoneBg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0F2A4A" />
          <stop offset="1" stopColor="#0A192F" />
        </linearGradient>
        <linearGradient id="landGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#12385F" />
          <stop offset="1" stopColor="#0D2748" />
        </linearGradient>
        <linearGradient id="zoneFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#F97316" stopOpacity="0.18" />
          <stop offset="1" stopColor="#F97316" stopOpacity="0.08" />
        </linearGradient>
        <filter id="softGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" />
        </filter>
      </defs>

      {/* Sea background */}
      <rect width="600" height="780" fill="url(#zoneBg)" />

      {/* Subtle grid */}
      <g stroke="#1B3862" strokeWidth="0.6" opacity="0.45">
        {Array.from({ length: 12 }).map((_, i) => (
          <line key={`v${i}`} x1={i * 50} y1="0" x2={i * 50} y2="780" />
        ))}
        {Array.from({ length: 16 }).map((_, i) => (
          <line key={`h${i}`} x1="0" y1={i * 50} x2="600" y2={i * 50} />
        ))}
      </g>

      {/* Land — approximate MD / DE / VA shapes (stylized, not geographically exact) */}
      {/* Western Maryland land block */}
      <path
        d="M0 140 L280 130 L305 175 L360 185 L365 250 L340 285 L305 305 L285 335 L260 360 L225 380 L195 405 L160 420 L120 425 L90 440 L60 460 L30 495 L0 520 Z"
        fill="url(#landGradient)"
        stroke="#1E4272"
        strokeWidth="1"
      />

      {/* Delmarva Peninsula (Eastern Shore MD + Delaware + tip of VA) */}
      <path
        d="M370 145 L470 130 L505 155 L520 195 L530 245 L525 300 L515 355 L495 410 L470 465 L445 520 L420 570 L395 615 L370 650 L345 675 L318 685 L295 675 L285 645 L295 605 L310 555 L325 500 L335 445 L340 385 L350 320 L358 260 L365 205 Z"
        fill="url(#landGradient)"
        stroke="#1E4272"
        strokeWidth="1"
      />

      {/* Virginia land south */}
      <path
        d="M0 560 L110 545 L180 555 L240 575 L285 610 L280 690 L230 720 L160 735 L80 745 L0 750 Z"
        fill="url(#landGradient)"
        stroke="#1E4272"
        strokeWidth="1"
      />

      {/* Region labels */}
      <text x="140" y="230" fill="#4A6A94" fontFamily="'Space Grotesk', sans-serif" fontSize="20" fontWeight="700" letterSpacing="4">
        MARYLAND
      </text>
      <text x="440" y="290" fill="#4A6A94" fontFamily="'Space Grotesk', sans-serif" fontSize="16" fontWeight="700" letterSpacing="3">
        DELAWARE
      </text>
      <text x="90" y="670" fill="#4A6A94" fontFamily="'Space Grotesk', sans-serif" fontSize="16" fontWeight="700" letterSpacing="3">
        VIRGINIA
      </text>

      {/* Zone highlight glow */}
      <path
        d="M345 130 Q460 115 520 160 Q555 220 545 300 Q535 380 505 470 Q470 570 415 640 Q375 690 335 700 Q295 705 275 665 Q265 605 285 535 Q305 445 320 355 Q330 260 340 175 Q343 145 345 130 Z"
        fill="#F97316"
        opacity="0.08"
        filter="url(#softGlow)"
      />

      {/* Zone outline (hand-drawn feel) */}
      <path
        d="M345 130 Q460 115 520 160 Q555 220 545 300 Q535 380 505 470 Q470 570 415 640 Q375 690 335 700 Q295 705 275 665 Q265 605 285 535 Q305 445 320 355 Q330 260 340 175 Q343 145 345 130 Z"
        fill="url(#zoneFill)"
        stroke="#F97316"
        strokeWidth="3.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />

      {/* City dots + labels within zone */}
      <ZoneCity cx={438} cy={200} label="Wilmington" />
      <ZoneCity cx={440} cy={270} label="Dover" />
      <ZoneCity cx={470} cy={340} label="Rehoboth" />
      <ZoneCity cx={410} cy={410} label="Salisbury" />
      <ZoneCity cx={455} cy={430} label="Ocean City" />
      <ZoneCity cx={390} cy={475} label="Pocomoke" />
      <ZoneCity cx={368} cy={320} label="Easton" />

      {/* Out of zone cities (for context) */}
      <OutCity cx={215} cy={260} label="Baltimore" />
      <OutCity cx={247} cy={320} label="Annapolis" />

      {/* Compass */}
      <g transform="translate(535, 720)">
        <circle r="22" fill="#0A192F" stroke="#F97316" strokeWidth="1.5" />
        <path d="M0 -14 L4 0 L0 14 L-4 0 Z" fill="#F97316" />
        <text x="0" y="-16" fill="#F97316" fontSize="9" fontWeight="700" textAnchor="middle">
          N
        </text>
      </g>

      {/* Scale bar */}
      <g transform="translate(30, 730)">
        <line x1="0" y1="0" x2="80" y2="0" stroke="#F97316" strokeWidth="2" />
        <line x1="0" y1="-4" x2="0" y2="4" stroke="#F97316" strokeWidth="2" />
        <line x1="80" y1="-4" x2="80" y2="4" stroke="#F97316" strokeWidth="2" />
        <text x="40" y="18" fill="#7A9AC4" fontSize="10" fontWeight="600" textAnchor="middle" fontFamily="'Space Grotesk', sans-serif">
          20 MILES
        </text>
      </g>
    </svg>
  );
}

function ZoneCity({ cx, cy, label }) {
  return (
    <g>
      <circle cx={cx} cy={cy} r="6" fill="#F97316" opacity="0.25" />
      <circle cx={cx} cy={cy} r="3" fill="#FFFFFF" stroke="#F97316" strokeWidth="1.5" />
      <text
        x={cx + 9}
        y={cy + 4}
        fill="#FFFFFF"
        fontSize="12"
        fontWeight="600"
        fontFamily="'Space Grotesk', sans-serif"
      >
        {label}
      </text>
    </g>
  );
}

function OutCity({ cx, cy, label }) {
  return (
    <g opacity="0.55">
      <circle cx={cx} cy={cy} r="2.5" fill="#7A9AC4" />
      <text
        x={cx + 7}
        y={cy + 4}
        fill="#7A9AC4"
        fontSize="11"
        fontWeight="500"
        fontFamily="'Space Grotesk', sans-serif"
      >
        {label}
      </text>
    </g>
  );
}
